import * as React from "react";
const SvgFiRrSell = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-sell_svg__a)">
      <path
        fill="#062147"
        d="M20 .017H4a4 4 0 0 0-4 4v4a4 4 0 0 0 4 4h1.108a3.9 3.9 0 0 1 3.363-2.978l.016-6.18a.777.777 0 0 1 .777-.775h1.939a.777.777 0 1 1-.027 1.554L10.07 3.6v1.65l1.15.04c.419.014.75.358.75.777v.044c0 .44-.365.792-.804.777L10.07 6.85V8.4h1.123c.429 0 .777.349.777.778v.68l5.935 2.159H20a4 4 0 0 0 4-4v-4a4 4 0 0 0-4-4M7.442 7.98c-.191 1.175-1.215 2.028-2.436 2.028-.664 0-1.3-.195-1.839-.552a.733.733 0 0 1-.119-1.131.73.73 0 0 1 .888-.111c.316.19.688.297 1.069.297.604 0 1.031-.404 1.096-.795.089-.55-.602-.873-.817-.96-.915-.37-1.751-.78-1.753-.78-.692-.483-1.027-1.23-.921-2.048a2.17 2.17 0 0 1 1.471-1.796c.839-.277 1.603-.076 2.152.203a.727.727 0 0 1 .24 1.093.725.725 0 0 1-.863.225c-.306-.134-.71-.226-1.137-.088-.412.136-.517.447-.515.577.005.442.335.57.433.615.282.128.806.368 1.366.595 1.461.59 1.828 1.746 1.685 2.628m9.529 1.225a.8.8 0 0 1-.796.799l-1.888.008a.8.8 0 0 1-.802-.8v-6.4a.8.8 0 1 1 1.598.003L15.078 5l-.008 3.4h1.102a.8.8 0 0 1 .799.799zm4.529-.003a.8.8 0 0 1-.799.799h-1.902A.8.8 0 0 1 18 9.2V2.8a.8.8 0 0 1 .799-.8h.002a.8.8 0 0 1 .799.8V8.4h1.102a.8.8 0 0 1 .799.799zm-5.479 9.402 2.686-2.686a1 1 0 0 0-.367-1.648l-8.731-3.162a1.96 1.96 0 0 0-2.031.472 1.96 1.96 0 0 0-.471 2.03l.006.018 3.156 8.714c.117.32.446.645.94.659a.97.97 0 0 0 .707-.293l2.689-2.69 3.686 3.69a1 1 0 0 0 1.415-1.414l-3.687-3.69zm-4.406 1.577-2.593-7.16 7.159 2.594z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-sell_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSell;
